<template>
  <div class='library'>
    <h2>图书馆</h2>
    <div class='content'>
      <div v-loading='loading' class='table-wrapper'>
        <!-- 列表 -->
        <table class='table'>
          <thead>
            <tr>
              <td v-for='item in tableItems' :key='item.idx' :style='{width:item.width}'>{{ item.label }}</td>
            </tr>
          </thead>
          <tbody v-if='list.length'>
            <tr v-for='item in list' :key='item.idx'>
              <td v-for='t in tableItems' :key='t.idx' :style='{width:item.width}'>
                <div v-if='t.props === "path"' class='cell'>
                  <a :href='item[t.props]' :download='item[t.props]'>点击下载</a>
                </div>
                <div v-else class='cell'>{{ item[t.props] }}</div>
              </td>
            </tr>
          </tbody>
          <p v-else class='no-data'>无数据</p>
        </table>
      </div>
      <page :total='total' @change='changePage'/>
    </div>
    <login-library v-if='showLogin' @successLogin='successLogin'/>
  </div>
</template>

<script>
import LoginLibrary from '@/components/LoginLibrary'
import Page from '@/components/Page'

import { TEXTBOOK_LIST } from '@/api'

export default {
  components: {
    LoginLibrary,
    Page
  },
  data() {
    return {
      loading: false,
      showLogin: false,
      total: 0,
      page: 1,
      list: [],
      tableItems: [
        { idx: 1, label: '序号', props: 'idx', width: '50px' },
        { idx: 2, label: '文件', props: 'name', width: '800px' },
        { idx: 3, label: '时间', props: 'gmt_modified', width: '200px' },
        { idx: 4, label: '下载', props: 'path', width: '150px' }
      ]
    }
  },

  created() {
    this.setActiveBar('LIBRARY')
    this.checkLogin()
  },

  methods: {
    // 翻页
    changePage(val) {
      this.page = val
      this.getList()
    },

    // 登录成功
    successLogin() {
      this.showLogin = false
      this.getList()
    },

    // 检测是否登录
    checkLogin() {
      if (!this.$store.state.libraryToken) this.showLogin = true
      else this.getList()
    },

    // 获取列表
    getList() {
      let para = {
        page: this.page
      }
      this.loading = true
      TEXTBOOK_LIST(para).then(res => {
        this.loading = false
        if (res.data.code === 0) {
          this._formatList(res.data.data.items)
          this.total = res.data.data.total_num
        } else if (res.data.code === 40002) {
          this.removeToken()
          this.checkLogin()
        }
      })
    },

    // 格式化列表
    _formatList(data) {
      this.list = []
      data.forEach((e, idx) => {
        e.idx = idx + 1
        this.list.push(e)
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";
.library {
  width: 1200px;

  h2 {
    font-size: 20px;
    color: #000;
    font-weight: 500;
    text-align: center;
  }

  .content {
    width: 1200px;
    margin-top: 32px;

    .table-wrapper {
      width: 1200px;
      overflow-x: scroll;
      position: relative;

      // 列表
      .table {
        width: 1200px;
        table-layout: fixed;
        border: 1px solid #999;
        font-size: 14px;
        text-align: center;
        box-sizing: border-box;

        tbody,
        thead {
          td {
            height: 40px;
            vertical-align: middle;
            box-sizing: border-box;
            border-bottom: 1px solid #dddddd;
            border-right: 1px solid #dddddd;
          }
        }

        thead td {
          background-color: @blue-d;
          color: #ffffff;
        }
        tbody {
          tr:nth-of-type(even) {
            background-color: @blue-l;
          }

          td {
            color: #4d4d4d;
          }

          a {
            font-size: 12px;
            color: @blue-d;
            display: inline-block;
            width: 84px;
            height: 25px;
            line-height: 25px;
            border: 1px solid #ddd;
            border-radius: 5px;
            text-align: center;
            background: #ffffff;
          }
        }

        .no-data {
          height: 50px;
          line-height: 50px;
          color: #999999;
          font-size: 20px;
          text-align: center;
          width: 1590px;
          background-color: #f0f0f0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Library.vue